<template>
  <div>
    <div class="map-container" ref="mapContainer">
      <div
        class="amap"
        id="container"
        :style="{ height: `${viewportHeight - 100}px` }"
      ></div>
    </div>
    <div class="input">
      <el-input v-model="input" placeholder="请输入设备名称">
        <el-button
          slot="append"
          @click="sou(input)"
          icon="el-icon-search"
        ></el-button
      ></el-input>
      <div class="devicesBox">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item>
            <template slot="title">
              <div class="left">设备列表</div>
            </template>
            <div
              v-for="(item, index) in user"
              :key="index"
              @click="sou(item.name)"
              style="cursor: pointer"
            >
              {{ item.name }}
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <ViewportSize @viewport-size-update="onViewportSizeUpdate"></ViewportSize>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import { devices } from "@/uitl/api";
import orderImg from "../assets/orderImg.jpg";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      map: null, //初始化 map 对象
      markers: [],
      input: "",
      user: [],
      viewportHeight: 0,
      activeName: 0,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    devices().then((res) => {
      res.data.data.forEach((item) => {
        item.location = item.location.split(",");
        item.location = item.location.map(Number);
      });
      this.user = res.data.data;
      this.initMap(this.user[0].location);
    });
  },
  methods: {
    onViewportSizeUpdate(width, height) {
      this.viewportHeight = height;
    },
    sou(data) {
      this.user.forEach((item) => {
        if (item.name == data) {
          this.initMap(item.location, 17);
        }
      });
    },
    resizeMap() {
      if (this.map) {
        this.map.resize();
      }
    },
    // 地图初始化
    initMap(value, size) {
      console.log(value);
      AMapLoader.load({
        key: "a1c4fb87d8885f662ce34e6f56b4ff89", //此处填入我们注册账号后获取的Key
        version: "2.0", //指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
          "AMap.Scale",
          "AMap.ToolBar",
          "AMap.ControlBar",
          "AMap.Geocoder",
          "AMap.Marker",
          "AMap.CitySearch",
          "AMap.Geolocation",
          "AMap.AutoComplete",
          "AMap.InfoWindow",
        ], //需要使用的的插件列表，如比例尺'AMap.Scale'等
        resizeEnable: true,
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: size || 11.5, //初始化地图级别
            center: value || [122.209186, 29.98865], //初始化地图中心点位置
            // mapStyle: "amap://styles/darkblue",
          });
          this.setMapMarker();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    // 点标记
    setMapMarker() {
      // 人员点标记设定
      this.user.forEach((item, i) => {
        // / 遍历生成多个标记点
        let marker = new AMap.Marker({
          map: this.map,
          zIndex: 99,
          position: item.location, // 经纬度对象new AMap.LngLat(x, y)，也可以是经纬度构成的一维数组[116.39, 39.9]
        });
        marker.setMap(this.map);
        this.markers.push(marker);
        this.markersClick(marker, item);
        marker.on("click", (e) => {
          this.markersClick(marker, item);
        });
      });
    },
    markersClick(marker, item) {
      let content =
        '<div class="forms">' +
        '<div class="forms-name">' +
        "设备名称：" +
        item.name +
        "</div>" +
        '<div class="forms-name">' +
        "设备地址：" +
        item.address +
        "</div>" +
        '<div class="forms-name">' +
        "设备信息：" +
        item.info +
        "</div>" +
        '<div class="forms-name">' +
        "质保期：" +
        item.warranty +
        "</div>" +
        '<img class="orderimg" src="' +
        orderImg +
        '" alt="" style="width: 200px;" />' +
        "</div>";

      // 初始化信息窗口

      if (!this.infoWindow) {
        // 初始化信息窗口
        this.infoWindow = new AMap.InfoWindow({
          content: content,
          offset: new AMap.Pixel(0, -30),
        });
      }
      this.infoWindow.open(this.map, marker._position);
    },
  },
};
</script>

<style scoped lang="less">
.map-container {
  position: relative;
  width: 100%;
  height: 100%; /* 设置父容器高度 */
}
.amap {
  width: 100%;
  height: 100%;
}
.input {
  position: absolute;
  left: 250px;
  top: 100px;
  z-index: 99;
  width: 300px;
}
.devicesBox {
  margin-top: 10px;
  // border-radius: 20px;
  width: 300px;
  font-size: 20px;
  font-weight: 600;
  padding-top: 10px;
  box-sizing: border-box;
  line-height: 40px;
  opacity: 0.9;

  .left {
    padding-left: 10px;
  }
  .orderimg {
    width: 200px;
    height: 200px;
  }
  .devicesList {
    padding-left: 10px;
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    border-top: 1px solid #000;
    font-size: 16px;
    font-weight: 0;
    text-align: left;
  }
}
</style>
//   markers.setLabel({
//           offset: new AMap.Pixel(-15, 10), //设置文本标注偏移量
//           content: '<div class="forms_title" >' + item.name + "</div>", //设置文本标注内容
//           direction: "right", //设置文本标注方位
//         });
//         let content =
//           '<div class="forms">' +
//           '<div class="forms-name">' +
//           "姓名：" +
//           item.name +
//           "</div>" +
//           '<div class="forms-name">' +
//           "状态：" +
//           item.name +
//           "</div>" +
//           '<div class="forms-name">' +
//           "联系方式：" +
//           item.name +
//           "</div>" +
//           '<div class="designate"  onclick="designate()">' +
//           "指派任务" +
//           "</div>" +
//           "</div>";
//         markers.content = content;
//         markers.on("click", this.markersClick, item); // marker.emit("click", { target: marker }); // 此处是设置是否默认出现信息窗体